import { FocusedSensorType } from 'state/useWeatherStationState';
import { AttributeConfig } from './WeatherStationsLayer.types';

export const WEATHER_STATIONS_SOURCE_ID = 'weather-stations';
export const WEATHER_STATIONS_POINT_ICONS_LAYER_ID =
  'weather-stations-point-icons-layer';
export const WEATHER_STATIONS_ARROW_ICONS_LAYER_ID =
  'weather-stations-arrow-icons-layer';
export const WEATHER_STATIONS_LABELS_LAYER_ID = 'weather-stations-labels-layer';
export const WEATHER_STATIONS_SELECTED_POINT_ICON_LAYER_ID =
  'weather-stations-selected-point-icon-layer';
export const SOURCE_LAYER = 'weatherstations_atmospheric';
export const MIN_ICON_ZOOM_LEVEL = 10;
export const MIN_LABEL_ZOOM_LEVEL = 11;
export const MAX_ICON_INTERPOLATION_ZOOM_LEVEL = 13;
export const BASE_CIRCLE_RADIUS = 3.5;

export const ATTRIBUTE_CONFIGS: Record<FocusedSensorType, AttributeConfig> = {
  airTemp: {
    propKey: 'air_temp',
    iconName: 'TemperatureIcon',
    unit: '°F',
  },
  windGust: {
    propKey: 'wind_gust',
    iconName: 'WindGustIcon',
    unit: 'mph',
  },
  relativeHumidity: {
    propKey: 'relative_humidity',
    iconName: 'HumidityIcon',
    unit: '%',
  },
  windSpeed: {
    propKey: 'wind_speed',
    iconName: 'WindSpeedIcon',
    unit: 'mph',
  },
  precipitation1Hr: {
    propKey: 'precipitation_1hr',
    iconName: 'PrecipitationIcon',
    unit: 'in/hr',
  },
  dewPointTemperature: {
    propKey: 'dew_point_temperature',
    iconName: 'DewPointIcon',
    unit: '°F',
  },
};
